import React, { Component } from 'react';
import PropTypes from 'prop-types';

class NoMatch extends Component {
  constructor(props) {
    super(props);

    if (props.staticContext) {
      // staticContext will only exist in server rendering;
      // 404s in client-side navigation wouldn't make sense anyway, resulting from a <Link /> to a non-existent component
      props.staticContext.status = 404;
    }
  }

  render() {
    return <div>404</div>;
  }
}

NoMatch.propTypes = {
  staticContext: PropTypes.object
};

export default NoMatch;
